import { Marker } from "react-map-gl/maplibre"

import type { TruckLocation } from "../../types/logisticsMapTypes.ts"

export default function TruckMarker({ truck }: { truck: TruckLocation }) {
  return (
    <Marker longitude={truck.longitude} latitude={truck.latitude}>
      <div className="bg-white font-sans font-semibold py-1 px-2 rounded-md text-metric-accent text-[12pt] shadow-sm border">
        {truck.number}
      </div>
    </Marker>
  )
}
